import { h } from 'preact'
import s from './Sprakvelger.module.css'
import { Link } from '../../shared/Link'
import { createUrlFor } from '../../../routes'
import { PageType, Locale } from '../../../domain'
import { Icon } from '../../shared/Icons/Icons'
import { useLocale } from '../../../../lib/intl/IntlProvider'
import { useAppState } from '../../../../lib/redux-provider-nohooks'
import { useCustomContext } from '../../../../lib/context'
import { GA_EVENTS } from '../../../../lib/analytics'

const CoreToggle = props => h('core-toggle', props)

export function Sprakvelger() {
  const locale = useLocale()
  const { page } = useAppState()
  const { sendGaEvent } = useCustomContext()
  const currentPage = page.current

  const handleSelect = (event, locale: Locale) => {
    event.target.closest('core-toggle').hidden = true
    sendGaEvent(GA_EVENTS.LOCALE_CHANGE(locale))
  }

  return (
    <div class={s.sprakvelger}>
      <button>
        Språk <Icon type="nrk-chevron-down" />
      </button>
      <CoreToggle hidden popup>
        <ul>
          <li>
            <Link
              linkClickType="LANG"
              href={createUrlFor(currentPage, 'nb')}
              onClick={event => handleSelect(event, 'nb')}
            >
              {locale === 'nb' && <Icon type="nrk-check" />}
              Bokmål
            </Link>
          </li>
          <li>
            <Link
              linkClickType="LANG"
              href={createUrlFor(currentPage, 'nn')}
              onClick={event => handleSelect(event, 'nn')}
            >
              {locale === 'nn' && <Icon type="nrk-check" />}
              Nynorsk
            </Link>
          </li>
          <li>
            <Link
              linkClickType="LANG"
              href={createUrlFor(currentPage, 'sme')}
              onClick={event => handleSelect(event, 'sme')}
            >
              {locale === 'sme' && <Icon type="nrk-check" />}
              Nordsamisk
            </Link>
          </li>
        </ul>
      </CoreToggle>
    </div>
  )
}
